import store from 'app/store';

export default function isAuth0User(state) {
  const { auth } = state || store.get().getState();

  return auth.get('isAuth0');
}
